module.exports = "/Public/build/a809f46c2d312d752ddb9d83471dd2b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DepartmentMarker/selskap-gul-42x49px.svg
// module id = 837
// module chunks = 0